import { Component } from '@angular/core'
import { State, Observable, Store, User, AppFields } from '../../store'

@Component({
  selector: 'app-side-menu-com',
  templateUrl: 'side-menu.com.html',
  styleUrls: ['side-menu.scss']
})

export class SideMenuComponent {

  userIsAdmin: Observable<boolean>
  data = {
    items: [
      { name: '库存', icon: 'glyphicon-th-large', link: '/inventory' },
      { name: '批次', icon: 'glyphicon-globe', link: '/batches' },
      { name: '入库', icon: 'glyphicon-download-alt', link: '/import' },
      { name: '财务', icon: 'glyphicon-usd', link: '/finance' },
      { name: '运营', icon: 'glyphicon-pushpin', link: '/operation' },
      { name: '关于', icon: 'glyphicon-plane', link: '/about' }
    ]
  }

  constructor(private store: Store<State>) {
    this.userIsAdmin = this.store.select(AppFields.App, AppFields.User).map(
      (user: User) => user && user.isAdmin
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/com/side-menu/side-menu.com.ts